import type NumberUnit from '@exodus/currency';

import type { Assets } from '@/types';

const cache = {};

const getAssetFromCurrency = ({
  amount,
  assets,
}: {
  amount: NumberUnit;
  assets: Assets;
}) => {
  const { unitType } = amount;
  const unitName = unitType.toString();
  if (cache[unitName]) {
    return cache[unitName];
  }

  cache[unitName] = Object.values(assets).find((asset) =>
    asset.currency.equals(unitType),
  );

  return cache[unitName];
};

export default getAssetFromCurrency;
